import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { Controller, Control, FieldError } from 'react-hook-form';

interface FormTextFieldProps extends Omit<TextFieldProps, 'name'> {
  name: string;
  control: Control<any>;
}

const FormTextField: React.FC<FormTextFieldProps> = ({ name, control, ...props }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }: { field: any; fieldState: { error?: FieldError } }) => (
        <TextField
          {...field}
          {...props}
          error={!!error}
          helperText={error?.message || props.helperText}
          fullWidth
          variant="outlined"
          sx={{
            ...props.sx
          }}
        />
      )}
    />
  );
};

export default FormTextField; 